import { handleResponse, handleError } from './api-utils';
import { apiConstants } from './api-constants';

export function getSSODefaultRegisterFormData() {
    return fetch(apiConstants.loadDefaultRegisterFormDataUrl, {
        method: 'GET',
        headers: { 'content-type': 'application/json' }
    })
        .then(handleResponse)
        .catch(handleError);
}

export function getSSOOneClubRegisterFormData(formDataUrl) {
    return fetch(formDataUrl)
        .then(handleResponse)
        .catch(handleError);
}

export function getSSOTicketingRegisterFormData() {
    return fetch(apiConstants.loadTicketingRegisterFormDataUrl, {
        method: 'GET',
        headers: { 'content-type': 'application/json' }
    })
        .then(handleResponse)
        .catch(handleError);
}

export function getSSORaMembersRegisterFormData() {
    return fetch(apiConstants.loadRaMembersRegisterFormDataUrl, {
        method: 'GET',
        headers: { 'content-type': 'application/json' }
    })
        .then(handleResponse)
        .catch(handleError);
}

export function registerNewUser(userRegistrationData, callbackUrl) {
    return fetch(callbackUrl, {
        method: 'POST',
        headers: { 'content-type': 'application/json' },
        body: JSON.stringify(userRegistrationData)
    })
        .then(handleResponse)
        .catch(handleError);
}

export function resendEmailVerification(userEmailData, callbackUrl) {
    return fetch(callbackUrl, {
        method: 'POST',
        headers: { 'content-type': 'application/json' },
        body: JSON.stringify(userEmailData)
    })
        .then(handleResponse)
        .catch(handleError);
}

export function verifyIfEmailAddressExists(userEmail, callbackUrl) {
    return fetch(callbackUrl, {
        method: 'POST',
        headers: { 'content-type': 'application/json' },
        body: JSON.stringify({ emailAddress: userEmail })
    })
        .then(handleResponse)
        .catch(handleError);
}
